//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fromItems from "./mixin/fromItems";
export default {
  mixins: [fromItems],
  name: "ykInputs",
  props: {
    value: {},
    type: {},
    rows: {},
    autosize: {},
    iconClass: String,
    vslot: String,
    maxlength: String,
    noFormEnter: {
      default: false
    },
    inline: {
      type: Boolean,
      default: true
    },
    change: {}
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  },
  mounted: function mounted() {},
  methods: {
    blur: function blur(val) {
      this.$emit("blur", val.currentTarget.value);
    },
    clear: function clear() {
      this.$emit("clear", "");
    },
    changex: function changex(val) {
      this.$emit("change", val);
    },
    onEnter: function onEnter(event) {
      if (!this.noFormEnter) {
        this.$parent.$parent.onFormEnter();
      }
      this.$emit("onEnter");
    },
    setCurrentValue: function setCurrentValue(value) {
      if (value === this.currentValue) return;
      this.currentValue = value;
    },
    handleInput: function handleInput(_value) {
      // if (this.value === undefined && this.$parent.model !== undefined && this.prop !== undefined) {
      //   this.$parent.model[this.prop] = _value;
      // } else {
      var value = _value;
      if (this.type === "number" && value !== "") {
        value = value * 1;
      }
      this.$emit("input", value);
      // }
    }
  },
  watch: {
    value: function value(val, oldValue) {
      this.setCurrentValue(val);
    },
    myclass: function myclass(val) {
      if (val.indexOf("v_input_no_lable")) {
        this.$parent.$el.style.lineHeight = "36px";
      }
    }
  }
};